import { format } from 'date-fns/esm';
import React, { useEffect } from 'react';

import {
  Card,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import ScheduleIcon from '@material-ui/icons/Schedule';

import CardTitle from '../../../common/card/CardTitle';
import { useFindAgreementVersions } from '../Agreement.hooks';
import { Agreement } from '../Agreement.interface';

export interface AgreementVersionCardProps {
  agreement: Agreement;
}

const AgreementVersionCard: React.FC<AgreementVersionCardProps> = ({
  agreement
}) => {
  const {
    agreementVersions,
    isLoading,
    findAgreementVersions
  } = useFindAgreementVersions(agreement.id);
  useEffect(() => {
    findAgreementVersions(); // refresh if agreement object is updated
  }, [findAgreementVersions, agreement]);
  return (
    <Card>
      <CardTitle>
        <ScheduleIcon />
        Agreement Versions
      </CardTitle>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Version</TableCell>
              <TableCell>Published</TableCell>
              <TableCell>Employee</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3} padding='none'>
                  <LinearProgress />
                </TableCell>
              </TableRow>
            )}
            {agreementVersions && agreementVersions.length > 0 ? (
              agreementVersions.map((agreementVersion, index) => (
                <TableRow key={agreementVersion.id} hover>
                  <TableCell>{agreementVersion.version}</TableCell>
                  <TableCell>
                    {format(agreementVersion.created, 'MMM d, yyyy')}
                  </TableCell>
                  <TableCell>
                    {agreementVersion.createdBy.firstName}{' '}
                    {agreementVersion.createdBy.lastName}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3}>
                  No published agreement versions
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default AgreementVersionCard;
